import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import NavBar from "../../components/Navbarr";
import SideBarAdmin from "../../components/SideBarAdmin";
import Footerr from "../../components/Footerr";
import AccessDenied from "../../components/AccessDenied";
import { UserContext } from "../../components/context/userContext";
import Modal from "react-modal";
import ModalCategorie from "../../components/ModalCategorie";
import { getCategories } from "../../services/get-categories";
import { toast } from "react-toastify";
import { getSubCategoriesWithCount } from "../../services/get-subCategories-with-count-prod";
import { addSubCategorie } from "../../services/post-subCategorie";
import { updateSubCategorie } from "../../services/put-subCategorie";
import ModalViderBasket from "../../components/ModalViderBasket";
import { deleteCategorie } from "../../services/delete-categorie";
import { deleteSubCategorie } from "../../services/delete-subcategory";
import { defaultOptionsLoading } from "../../assets/lottie-animations/animationOptions";
import Lottie from "react-lottie";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "50vh",
    borderWidth: 0.2,
    borderRadius: 12,

    background: "#fff",
  },
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
function SubCategories() {
  const { height, width } = useWindowDimensions();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [subCategorieToEdit, setSubCategorieToEdit] = useState<any>();
  const [openDeleteModal, setOpenDeletModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  function closeDeleteModal() {
    setOpenDeletModal(false);
  }
  const openEditMode = (categorie: any) => {

    setSubCategorieToEdit(categorie);
    setIsOpen(true);
    setSelectedOption({
      label: categorie?.category.name,
      value: categorie?.category._id,
    });
  };
  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setSelectedOption({ label: "", value: "" });
    setIsOpen(false);
  }

  const doGetSubCategories = () => {
    setLoading(true);
    getSubCategoriesWithCount()
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          setSubCategories(response?.content);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };
  const doAddSubCategorie = (values) => {
    const data = { name: values?.name, category: selectedOption?.value };
    addSubCategorie(data)
      .then((response) => {
        if (response?.status === 500) {
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          toast.success("subCategorie added successfuly !");
          doGetSubCategories();
          closeModal();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const doGetCategories = () => {
    getCategories()
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          setCategories(response?.content);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const doUpdateSubCategorie = (values) => {
    const data = { name: values?.name, category: selectedOption?.value };
    updateSubCategorie(subCategorieToEdit?._id, data)
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          toast.success("SubCategorie updated successfuly !");
          doGetSubCategories();
          closeModal();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  const doDeleteCategorie = () => {
    deleteSubCategorie(itemToDelete?._id, user?._id, token)
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          toast.success("categorie deleted successfuly !");
          doGetSubCategories();
          closeDeleteModal();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    doGetSubCategories();
    doGetCategories();
  }, []);

  return (
    <>
      {user?.role == 1 ? (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <div className="side-bar-container">
              <SideBarAdmin widthWindow={width} screen={"subCategories"} />
            </div>
            <div className="body-container">
              <div className="header-body">
                <div className="header-left">
                  <h2>SubCategories</h2>
                </div>
                <button
                  className="add-categorie-btn"
                  onClick={() => openModal()}
                >
                  Ajouter <i className="bx bx-plus"></i>
                </button>
              </div>
              <div className="line" />
              {loading ? (
                <div className="admin-loader">
                  <Lottie
                    options={defaultOptionsLoading}
                    height={150}
                    width={150}
                  />
                </div>
              ) : (
                <div className="boxes-container">
                  {subCategories?.length > 0 ? (
                    subCategories?.map((categorie, index) => (
                      <div className="one-box-content" key={categorie?._id || index}>
                        <div className="box-actions">
                          <i
                            className="bx bx-edit icon-action"
                            title="Edit"
                            onClick={() => openEditMode(categorie)}
                          ></i>
                          <i
                            className="bx bx-trash icon-action danger"
                            title="Delete"
                            onClick={() => {
                              setItemToDelete(categorie);
                              setOpenDeletModal(true);
                            }}
                          ></i>
                        </div>
                        <div className="box-body">
                          <span className="box-title">{categorie?.name}</span>
                          <span className="box-meta">
                            {categorie?.countProducts} products
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="boxes-empty">No subcategories found</div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      ) : (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <AccessDenied />
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalCategorie
          closeModal={closeModal}
          doGetCategories={doGetSubCategories}
          doAdd={doAddSubCategorie}
          addType={"subCategorie"}
          categoriesData={categories}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          categorieToEdit={subCategorieToEdit}
          setCategoryToEdit={setSubCategorieToEdit}
          doUpdateCategorie={doUpdateSubCategorie}
        />
      </Modal>
      <Modal
        isOpen={openDeleteModal}
        onRequestClose={closeDeleteModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalViderBasket
          text={`Êtes-vous sûr de vouloir supprimer ${itemToDelete?.categoryName} ?`}
          closeModal={closeDeleteModal}
          action={doDeleteCategorie}
        />
      </Modal>
    </>
  );
}

export default SubCategories;
